
import { mapActions, mapState, mapGetters } from "vuex";
import { ORDER_ACCEPTED, ORDER_DELIVERED } from "@/constants/MixpanelEvents.js";
import OrderNewActionDialog from "../dialogs/order-new-action-dialog.vue";
import OrderRejectReasonDialog from "../dialogs/order-reject-reason-dialog.vue";
import OrderReadyForDeliveryActionDialog from "../dialogs/order-ready-for-delivery-action-dialog.vue";
import OrderPickedUpActionDialog from "../dialogs/order-picked-up-action-dialog.vue";
import OrderHighTemperatureDialog from "../dialogs/order-high-temperature-dialog.vue";

export default {
  props: {
    order: {
      type: Object,
      default: () => {}
    },
    status: {
      type: String,
      default: ""
    },
    isOrderAutoAcceptEnabled: {
      type: Boolean,
      default: false
    },
    isDispatchTimedOut: {
      type: Boolean,
      default: false
    },
    isModificationEnabled: {
      type: Boolean,
      default: false
    },
    itemOutOfStockLoading: {
      type: Boolean,
      default: false
    },
    isUpdateAndNotifyButton: {
      type: Boolean,
      default: false
    }
  },

  components: {
    OrderNewActionDialog,
    OrderRejectReasonDialog,
    OrderReadyForDeliveryActionDialog,
    OrderPickedUpActionDialog,
    OrderHighTemperatureDialog
  },

  data() {
    return {
      newOrderActionDialog: false,
      rejectOrderReasonDialog: false,
      readyForDeliveryActionDialog: false,
      pickedUpActionDialog: false,
      orderActionLoading: false,
      orderDetailObj: {}
    };
  },
  computed: {
    ...mapState("restaurant", ["printers", "locationDetails"]),
    ...mapGetters("restaurant", ["getRecieverSettings"])
  },
  beforeMount() {
    this.$nuxt.$on("trigger-order-next-action", this.handleOrderNextAction);
  },
  methods: {
    ...mapActions("reciever", [
      "patchOrderStatus",
      "getOrderDetailsObj",
      "markOrderAsComplete"
    ]),

    navigateToReceiverPage() {
      this.$router.push("/reciever");
    },
    handleOrderNextAction(id) {
      if (this.order.id === id) {
        this.$refs["order-action-btn"].children[0].click();
      }
    },
    handleRejectOrder(orderDetailObj) {
      this.orderDetailObj = orderDetailObj;
      this.newOrderActionDialog = false;
      this.rejectOrderReasonDialog = true;
    },
    newOrderAction(order) {
      if (
        this.getRecieverSettings(this.orderDetailObj.restaurant_id)
          .enable_auto_accept
      ) {
        const $this = this;
        $this.orderActionLoading = true;
        $this
          .patchOrderStatus({
            orderId: order.id,
            payload: {
              new_status: "Acknowledged"
            }
          })
          .then((response) => {
            if (response.status === 200) {
              this.mixPanelTrackEvent(ORDER_ACCEPTED);
              $this
                .getOrderDetailsObj({
                  orderId: $this.order.id
                })
                .then((response) => {
                  if (response) {
                    $this.kotPrintAllItems(response);
                  } else {
                    $this.$nuxt.$emit("show-error-toast", response);
                  }
                })
                .catch((errr) => {
                  $this.$nuxt.$emit("show-error-toast", errr);
                });
            } else {
              $this.$nuxt.$emit("show-error-toast", response);
            }
          })
          .catch((errr) => {
            console.log(errr);
            $this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            $this.orderActionLoading = false;
          });
      } else {
        this.newOrderActionDialog = true;
      }
    },
    readyForDeliveryAction() {
      this.readyForDeliveryActionDialog = true;
    },

    handleCancelModification() {
      this.$emit("hide-availibility-toggle");
      this.$nuxt.$emit("availability-toggled-on");
    },

    handleOrderModification() {
      this.$emit("modify-and-inform-customer");
    },

    pickedUpAction() {
      this.pickedUpActionDialog = true;
    },
    completedAction() {
      const isWhatsappAndOwnDelivery =
        this.locationDetails?.restaurants?.[0]?.restaurant_platforms?.some(
          (platform) =>
            platform.platform_name === "whatsapp" &&
            platform.delivery_partner === "own_delivery"
        );

      if (
        this.isDispatchTimedOut ||
        (this.order.source === this.$constants.Channels.WHATSAPP.name &&
          isWhatsappAndOwnDelivery)
      ) {
        this.orderActionLoading = true;
        this.markOrderAsComplete({ orderId: this.order.id })
          .then((response) => {
            this.mixPanelTrackEvent(ORDER_DELIVERED);
            this.$nuxt.$emit("show-toast", {
              text: response.data.message,
              color: "success darken-2",
              icon: "done",
              flat: true
            });
          })
          .catch((errr) => {
            console.log(errr);
            this.$nuxt.$emit("show-error-toast", errr);
          })
          .finally(() => {
            this.orderActionLoading = false;
          });
      } else {
        this.$nuxt.$emit("show-info-dialog", {
          content:
            "Sorry. You cannot take this action. The order automatically completed after completing the delivery"
        });
      }
    },
    kotPrintAllItems(order) {
      this.$nuxt.$emit(
        "initiate-print",
        order,
        "kot",
        false,
        true,
        false,
        false,
        true,
        this.printers
      );
      if (
        this.getRecieverSettings(order.restaurant_id)
          .enable_consolidated_kot_printer
      ) {
        this.$nuxt.$emit(
          "initiate-print",
          order,
          "master-kot",
          false,
          true,
          false,
          false,
          true,
          this.printers
        );
      }
    }
  }
};
